/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Tier_DeletedInputs */

const vi_shop_tier_deleted = /** @type {(inputs: Shop_Tier_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã xoá hạng thành viên.`)
};

/**

* @param {Shop_Tier_DeletedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_tier_deleted = /** @type {((inputs?: Shop_Tier_DeletedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Tier_DeletedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_tier_deleted(inputs)
});